module.exports = __webpack_public_path__ + "img/rotating-icon.9e2a1328.svg";